const ITEMS = [
  "OPEN WORLD",
  "NO PLAN B",
  "KEEP MACK",
  "BUILT NOT BORN",
  "COMEBACK IN PROGRESS",
  "TECH AS A LIFELINE",
  "EVERY FOLLOW COUNTS",
];

export const Marquee = () => {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee-section"
      className="relative z-20 border-y border-matrix-green/15 bg-matrix-ink/40 py-8 overflow-hidden"
    >
      <div className="marquee-track flex w-max whitespace-nowrap will-change-transform">
        {loop.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 font-display text-4xl font-black uppercase tracking-tight text-transparent sm:text-6xl" style={{ WebkitTextStroke: "1px rgba(0,255,136,0.5)" }}>
              {item}
            </span>
            <span className="text-3xl text-matrix-orange sm:text-5xl" style={{ textShadow: "0 0 14px #ff9900" }}>
              &bull;
            </span>
          </span>
        ))}
      </div>
    </section>
  );
};
